import {
  ApiPostResponse,
  AuthVerifyApiBody,
  AuthVerifyApiResponse,
  OnboardingSkipBody,
  OnboardingStepBody,
} from '../../../../types/interfaces'
import { client } from '../../client'

export class AuthService {
  public async logoutAccount() {
    return client.post<ApiPostResponse>('/auth/logout', {})
  }

  public async skipOnboadingStep(body: OnboardingSkipBody) {
    return client.post<ApiPostResponse>('/auth/onboard-skip', body)
  }

  public async updateOnboading(body: OnboardingStepBody) {
    return client.post<ApiPostResponse>('/auth/onboard', body)
  }

  public async verifyAccount(body: AuthVerifyApiBody) {
    return client.post<AuthVerifyApiResponse>('/auth/verify', body)
  }
}
